import React from 'react';

interface ILabelProps {
    title: string;
    textSize?: string;
    labelClassName?: string;
}


const Label: React.FC<ILabelProps> = ({ title, textSize = "sm", labelClassName }) => {
    return (
        <label className={`text-${textSize} font-semibold text-msi-midblue-color-500 ${labelClassName}`}>{title}</label>
    );
    
};

export default React.memo(Label);